
import React, { useState,useContext,useEffect } from "react";

import { Auth } from "aws-amplify";
import { Redirect } from 'react-router-dom';
import { signUp,postSignUp } from "../../apis/auth";
import Loading from "../Loading";
import {PageContext} from '../../PageContext';
import {PAGE} from "../../constants"
import {setLoginMessage} from "../../apis/sharedata"

export function Signup() {

    let styles = { marginBottom: '15px' };

    // const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [companyName,setCompanyName] = useState("");
    const [password, setPassword] = useState("");
    const [repassword, setRepassword] = useState("");
    const [isConfirmSignUp, setIsConfirmSignUp] = useState(false);
   
    const [isConfirmSignUpComplete, setIsConfirmSignUpComplete] = useState("");
    const [formError,setFormError] = useState("");
    const [signUpInProgress,setSignUpInProgress] = useState(false);
    const {page, setPage} = useContext(PageContext);
    const [phoneno,setPhoneno] = useState("");
    const [firstName,setFirstName] = useState("");
    const [lastName,setLastName] = useState("");
  



    async function onSubmit(event) {
        event.preventDefault();
        let signUpObj = {};
        signUpObj.firstName = firstName;
        signUpObj.lastName = lastName;
        signUpObj.userName = email;
        signUpObj.password = password;
        signUpObj.companyName = companyName;
        signUpObj.phoneno = phoneno;
        signUpObj.handleSignUpSuccess = handleSignUpSuccess;
        signUpObj.handleSignUpFailure = handleSignUpFailure;
        signUp(signUpObj);
        
    }

    function handleSignUpFailure(err){
        setFormError(err);
    }

    function handleSignUpSuccess(err){
        console.log("Signup for " + email +" is successfull. Directing to Verification code screen");
        setIsConfirmSignUp(true);
    }
    //TODO: to be removed
    async function onVerificationCode(userName,verificationCode) {
        //event.preventDefault();
        console.log("Inside onVerification");
        console.log(verificationCode);
        setSignUpInProgress(true);
        await Auth.confirmSignUp(userName, verificationCode)
        .then((res) => {
            if(res === "SUCCESS"){
               
                postSignUp(userName,companyName)
                .then((res) => {
                    console.log("Displaying response from confirmSignUp "+res);
                    console.dir(res);
                    if(res != res.ok){       
                        return res.json();
                     }else{
                        const newLocal = "Post Signup failed. Response is not ok. Server Error";
                        console.error(newLocal);
                        throw new Error(newLocal);
                    }
                })
                .then((resdata)=>{
                     console.log(JSON.stringify(resdata))
                     console.log("redirecting to login page");
                     setSignUpInProgress(false);
                     setIsConfirmSignUpComplete(true);
                     
                })
                .catch((err)=>{
                    
                    console.error("PostSignUp failed with exception "+ err.message);
                    throw new Error(err.message);
                })
                
            }else{
                console.error("verification code confirmation failed");
                throw new Error("verification code confirmation failed");
            }
        })
        .catch((err)=> {
            console.error(err.message);
            throw new Error(err.message);
        })
            
        

    }

    if(isConfirmSignUpComplete){
        setLoginMessage("Signup is complete. Please log with your credentials");
        setPage(PAGE.LOGIN)
    }
   

    if (isConfirmSignUp) {
        return (
            <div className="topcontainer-signup" >
                <h1>Email Verification</h1>
                <p>A verfication link is sent to {email}. Please click on the link in the email to complete Verification</p>
                <p> <a href="" onClick={(e)=>{e.preventDefault();setPage(PAGE.LOGIN)}}>Back to Login</a></p>
                {/* <hr />
                {getLoading()}
                <form onSubmit={onVerificationCode}>
                    <input type="text" value={verificationCode} 
                        className="ipc" onChange={(event) => setVc(event.target.value)} 
                        placeholder="Enter Verification code" name="verificationcode" required />
                    <button type="submit" className="ips ipc">Submit</button>
                </form> */}
            </div>
        );
    }



    function onClickPostSignUp(){
        postSignUp(email,companyName);
    }

    function getLoading(){      
        return <Loading loading = {signUpInProgress} />
    }

    return (
        
        
        <div className="topcontainer-signup">
            
            <form onSubmit={onSubmit}>
                <div >

                    <h1>Sign Up</h1>
                    <h4>Please fill in this form to create an account.</h4>
                    {formError && <p style={{color:"red"}}>{formError}</p>}
                    <hr />


                    <input type="text" value={email} className="ipc" onChange={(event) => setEmail(event.target.value.toLowerCase())} placeholder="Enter Email" name="email" required />
                    <input type="text" value={companyName} className="ipc" onChange={(event) => setCompanyName(event.target.value)} placeholder="Enter Company Name" name="companyname" required />
                    <input type="text" value={firstName} className="ipc" onChange={(event) => setFirstName(event.target.value)} placeholder="Enter First Name" name="firstname" required />
                    <input type="text" value={lastName} className="ipc" onChange={(event) => setLastName(event.target.value)} placeholder="Enter Last Name" name="lastname" required />
                    <input type="text" value={phoneno} className="ipc" onChange={(event) => setPhoneno(event.target.value)} placeholder="Enter Phone number" name="phoneno" />
                    <input type="password" value={password} className="ipc" onChange={(event) => setPassword(event.target.value)} placeholder="Password" required />
                    <input type="password" value={repassword} className="ipc" onChange={(event) => setRepassword(event.target.value)} placeholder="Repeat Password" required />

                    <hr />

                    <label>
                        <input type="checkbox" checked="checked" name="remember" style={styles} /> Remember me
                    </label>

                    <h4>By creating an account you agree to our <a href="#" style={{ color: "dodgerblue" }}>Terms & Privacy</a>.</h4>
                    <div className="clearfix">
                        <button type="submit" className="ips ipc">Sign Up</button>
                        <a href="" onClick={(e)=>{e.preventDefault();setPage(PAGE.LOGIN)}}>Back to Login</a>
                        
                    </div>


                </div>

            </form>
            
        </div>
    );

}